module.exports = __webpack_public_path__ + "img/logo.de7514d7.png";